import thousandSeparatorWithCurrency from '@entegral/helpers.formatters/price/thousand-separator-with-currency';

export function Price({ price, currency, priceUnit, status, term }) {
  return (
    <div className={`property-card__price`}>
      {price ? (
        <>
          {thousandSeparatorWithCurrency(price, currency, ` `, ` `)}
          {priceUnit === 'sqm' ? ' / m²' : ''}
          {status === `To Rent` ? (term === 'Daily' ? ' / day' : ' / month') : ''}
        </>
      ) : (
        'POA'
      )}
    </div>
  );
}
